























import { Component, Vue } from 'vue-property-decorator';
import MobileHeaderMenu from '@/views/layout/MobileHeaderMenu.vue';
import Routes from '@/util/Routes';
import { getModule } from 'vuex-module-decorators';
import OrderStore from '@/stores/order/order.store';
import { DeliveryMethodDto } from '@/api';
import SearchBar from '@/views/search/SearchBar.vue';
import { Urls } from '@/util/Urls';
import SearchSuggestionDropdown from '@/views/search/SearchSuggestionDropdown.vue';
import SearchBarStore from '@/stores/search/searchBar.store';

@Component({
  components: {SearchSuggestionDropdown, SearchBar, MobileHeaderMenu},
})
export default class MobileHeader extends Vue {
  public routes = Routes;
  private open: boolean = false;
  private orderStore = getModule(OrderStore, this.$store);
  private searchBarStore = getModule(SearchBarStore, this.$store);

  get isDelivery(): boolean {
    return this.orderStore.currentDeliveryMethod === DeliveryMethodDto.DELIVERY;
  }

  get duringCheckout(): boolean {
    return this.$route.matched.some((record) => record.meta.checkoutHeader);
  }

  get duringRegistration(): boolean {
    return this.$route.matched.some((record) => record.meta.isRegisterHeader);
  }

  get isNormalHeader(): boolean {
    return !this.duringCheckout && !this.duringRegistration;
  }

  get showSearchSuggestions(): boolean {
    return this.searchBarStore.isSearchBarActive;
  }

  public get logoUrl(): string {
    return Urls.logoPath();
  }

  public openMenu(): void {
    this.open = true;
  }

  public closeMenu(): void {
    this.open = false;
  }
}
